import { create } from "zustand";

const getStoredToken = () => localStorage.getItem("token") || "";

const TokenSlice = create((set) => ({
  token: getStoredToken(),
  isAuthenticated: !!getStoredToken(),

  setToken: (token) => {
    localStorage.setItem("token", token);
    set({
      token,
      isAuthenticated: true,
    });
  },

  clearToken: () => {
    localStorage.removeItem("token");
    set({
      token: null,
      isAuthenticated: false,
    });
  },
}));

export default TokenSlice;